import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import ShowPage from './pages/Landing/ShowPage';
import ShowTest from './pages/Landing/ShowTest';
import DeleteAccount from './pages/DeleteAccount';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/landing/show" element={<ShowPage />} />
      {/* Video Landing Page for A/B Testing */}
      <Route path="/landing/showtest" element={<ShowTest />} />
      {/* Policy Pages */}
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
    </Routes>
  );
}

export default App;
